const removeNewLineWhitespace = (word: string, replaceValue = "") => {
  if (!word) {
    return "";
  }
  return word.replace(/\s+/gm, replaceValue);
};
export default removeNewLineWhitespace;
